import { useQuery } from '@tanstack/react-query';

import { listMyOrganizations } from '@/api/orgs';
import { publicURL } from '@/api/media';

// useOrgCrest returns the club's own logo URL for a slug, or null when the club
// hasn't uploaded one (callers fall back to a monogram). Used by the calendar
// surfaces so a fixture shows OUR crest next to our team and the opponent's next
// to theirs.
//
// Reads the same ['my-orgs'] cache the dashboard shell already populated, so it
// costs no extra request. Resolves to the full-resolution object rather than the
// resize-worker variant: crests render at 14–32px where the size difference is
// irrelevant, and the original is the one key guaranteed to exist (a logo
// uploaded seconds ago has no variant yet).
export function useOrgCrest(token: string | null, slug: string): string | null {
  const { data } = useQuery({
    queryKey: ['my-orgs'],
    queryFn: () => listMyOrganizations(token),
    enabled: !!token,
  });
  const key = data?.find((o) => o.slug === slug)?.logo_object_key ?? '';
  return key ? publicURL(key) : null;
}
